module.exports = __webpack_public_path__ + "img/path-forward.0d0bb8d5.svg";